import { Row } from 'components/shared/Layout';
import styled from 'styled-components';
import ActionButton from 'components/ui/Button';

import { colours } from 'themes/default';

export const StyleHeaderItems = styled.div`
  margin: 8px 0;
  font-weight: 500;
  color: ${colours.Greyscale.White};

  position: relative;
  padding: 0 20px;

  &::before {
    background: white;
    content: '';
    height: 100%;
    left: 0;
    display: block;
    position: absolute;
    top: 0;
    width: 1px;
  }

  &:first-child {
    padding-left: 0;

    &::before {
      display: none;
    }
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const StyleHeaderItem = styled.span`
  margin-left: 10px;
  font-weight: 200;
`;

export const StyledBody = styled(Row)`
  background: ${colours.Greyscale.White};
  border: solid #ddd 1px;
  height: ${({ hide }) => (hide ? '0' : 'auto')};
  padding: ${({ hide }) => (hide ? '0 16px' : '16px')};
  overflow: hidden;
`;

export const StyledInfoWithPriceWrapper = styled.div`
  width: 45%;
`;

export const StyledCostRow = styled(Row)`
  p {
    margin: 0;
  }
`;

export const StyledAmount = styled.p`
  text-align: left;
`;

export const StyledActionButton = styled(ActionButton)`
  margin-left: 16px;
`;

export const StyledAssistancebox = styled.div`
  margin-bottom: 10px;
`;
